export const kvpConstants = {
    SET_KVP: 'SET_KVP',
    RESET_KVP: 'RESET_KVP',
    DELETE_KVP: 'DELETE_KVP',
    CLEAR_ALL_KVP: 'CLEAR_ALL_KVP',
}